import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import InputWrapDiv from "../../components/common/InputWrapDiv";
import TopBoxDiv from "../../components/common/TopBoxDiv";
import CodeSelectBox from "../../components/common/CodeSelectBox";
import ContentInput from "../../components/common/ContentInput";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import FunctionButton from "../../components/common/FunctionButton";
import { useTranslation } from "react-i18next";

// TODO : 메뉴 추가 시 PDI_AUTH 테이블에도 추가
const PdiMenuManagementEditPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [majorCode, setMajorCode] = useState(null);
  const [groupCode, setGroupCode] = useState(null);
  const [url, setUrl] = useState("");
  const [desc, setDesc] = useState("");
  const [code, setCode] = useState("");
  const [useYn, setUseYn] = useState(1);

  const [sbMajorCode, setSbMajorCode] = useState([
    { code: null, codeDesc: "Major Menu" },
  ]);
  const [sbGroupCode, setSbGroupCode] = useState([
    { code: null, codeDesc: "Group Menu" },
  ]);

  useEffect(() => {
    loadMajorCodeData();
  }, []);

  const loadMajorCodeData = () => {
    api
      .post("/manage/pdimenu/code", {
        level: 0,
      })
      .then((response) => {
        setSbMajorCode([
          { code: null, codeDesc: "Major Menu" },
          ...response.data.map((item) => ({
            ...item,
            codeDesc: item.desc,
          })),
        ]);
      })
      .catch(() => {});
  };

  const handleMajorCodeChange = (e) => {
    setMajorCode(parseInt(e.target.value));
    setGroupCode(null);

    api
      .post("/manage/pdimenu/code", {
        majorCode: parseInt(e.target.value),
        level: 1,
      })
      .then((response) => {
        setSbGroupCode([
          { code: null, codeDesc: "Group Menu" },
          ...response.data.map((item) => ({
            ...item,
            codeDesc: item.desc,
          })),
        ]);
      })
      .catch(() => {});
  };

  const handleGroupCodeChange = (e) => {
    setGroupCode(parseInt(e.target.value));
  };

  const handleUrlChange = (e) => {
    setUrl(e.target.value.trim());
  };

  const handleDescChange = (e) => {
    setDesc(e.target.value);
  };

  const handleCodeChange = (e) => {
    setCode(e.target.value.trim());
  };

  const handleUseYnChange = (e) => {
    setUseYn(parseInt(e.target.value));
  };

  const handleSubmit = () => {
    if (!validate()) {
      return;
    }

    api
      .post("/manage/pdimenu/add", {
        majorCode: majorCode,
        middleCode: groupCode,
        url: url,
        desc: desc.trim(),
        code: code,
        useYn: useYn,
      })
      .then(() => {
        navigate(-1);
      })
      .catch(() => {});
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const [errors, setErrors] = useState({
    validDesc: "",
    validCode: "",
  });

  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!desc) {
      tempErrors.validDesc = "Menu DESC is required.";
      isValid = false;
    }

    if (!code) {
      tempErrors.validCode = "Menu CODE is required.";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0463")]}></BreadCrumbDiv>

      <InputWrapDiv>
        <TopBoxDiv value={t("L0016")}></TopBoxDiv>

        <table>
          <tbody>
            <tr>
              <th>Major Menu</th>
              <td>
                <CodeSelectBox
                  value={majorCode}
                  codes={sbMajorCode}
                  onChange={handleMajorCodeChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="96%"
                  style={{
                    backgroundColor: "#f6f3f2",
                  }}
                />
              </td>
            </tr>
            <tr>
              <th>Group Menu</th>
              <td>
                <CodeSelectBox
                  value={groupCode}
                  codes={sbGroupCode}
                  onChange={handleGroupCodeChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="96%"
                  style={{
                    backgroundColor: "#f6f3f2",
                  }}
                />
              </td>
            </tr>
            <tr>
              <th>URL</th>
              <td>
                <ContentInput
                  value={url}
                  maxLength={500}
                  onChange={handleUrlChange}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>
                Menu DESC *
                {errors.validDesc && (
                  <>
                    <br />
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {errors.validDesc}
                    </span>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  value={desc}
                  maxLength={100}
                  onChange={handleDescChange}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>
                Menu CODE *
                {errors.validCode && (
                  <>
                    <br />
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {errors.validCode}
                    </span>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  value={code}
                  maxLength={10}
                  onChange={handleCodeChange}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>USE YN</th>
              <td>
                <table style={{ border: "none" }}>
                  <thead style={{ display: "none" }}>
                    <tr>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="radio"
                          id="radioY"
                          name="useYn"
                          value="1"
                          checked={useYn === 1}
                          onChange={handleUseYnChange}
                        />
                        <label
                          htmlFor="radioY"
                          style={{ paddingLeft: "22px", lineHeight: "17px" }}
                        >
                          Y
                        </label>
                      </td>
                      <td>
                        <input
                          type="radio"
                          id="radioN"
                          name="useYn"
                          value="0"
                          checked={useYn === 0}
                          onChange={handleUseYnChange}
                        />
                        <label
                          htmlFor="radioN"
                          style={{ paddingLeft: "22px", lineHeight: "17px" }}
                        >
                          N
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </InputWrapDiv>

      <ButtonWrapDiv className="btn_bottom">
        <FunctionButton
          className="big"
          value={t("L0659")}
          onClick={handleSubmit}
        ></FunctionButton>
        <FunctionButton
          className="big bg_gray"
          value={t("L0005")}
          onClick={handleCancel}
        ></FunctionButton>
      </ButtonWrapDiv>
    </div>
  );
};
export default PdiMenuManagementEditPage;
